import React, { useEffect, useState } from 'react';

import { useFlags } from 'launchdarkly-react-client-sdk';

import { getCorporateClubExtract } from 'services/api';
import { GetCorporateClubExtract } from 'services/api/corporate-club/types';

import LeftCard from './LeftCard';
import RightCard from './RightCard';

const MyTeam = () => {
  const { apiDomain } = useFlags();

  const [corporateClubExtract, setCorporateClubExtract] = useState<GetCorporateClubExtract>();

  useEffect(() => {
    getCorporateClubExtract(apiDomain).then((res) => setCorporateClubExtract(res));
  }, [apiDomain]);

  return (
    <div className="my-team" id="my-team">
      <div className="my-team__container">
        <h2 className="my-team__container__title">Minha equipe</h2>
        <div className="my-team__container__cards">
          <LeftCard registeredPeople={10} />
          <RightCard
            hasClub={corporateClubExtract?.status === 'active'}
            availablePlans={corporateClubExtract?.avaliablePlans}
            activeCounter={corporateClubExtract?.activePlans}
          />
        </div>
      </div>
    </div>
  );
};

export default MyTeam;
